import * as actionTypes from './ConfigActions';
import { updateObject } from '../../utility';

const initialState = {
    alarms: {},
};

const configReducerUpdater = (state, action) => {
    return updateObject(state, {
        ...action,
    });
};

const configReducer = (state = initialState, action) => {
    if (action.type in actionTypes) {
        return configReducerUpdater(state, action);
    }
    return state;
};

export default configReducer;
